(function ($) {
    
    $('.dropdown-panel').on('show.bs.collapse', function (e) {
        $('.dropdown-panel.show').collapse('hide');

        $(document).on('click.dropdownPanel', event => {
            var target = event.target
            var closest = '.dropdown-panel, .dropdown-link'

            if (!$(target).closest(closest).length) {
                $('.dropdown-panel.show').collapse('hide')
                $(document).off('click.dropdownPanel')
            }
        })
    })

})(jQuery);